import { products } from "@/mocks/site-data";

export default function ProductsSection() {
  const featuredProduct = products.find((p) => p.id === "ie");
  const otherProducts = products.filter((p) => p.id !== "ie");

  return (
    <section className="py-20 md:py-28 bg-background-50">
      <div className="w-full px-4 md:px-8 lg:px-12">
        <div className="text-center mb-14 md:mb-20">
          <span className="inline-block px-4 py-1.5 rounded-full bg-primary-50 text-primary-700 text-xs font-semibold tracking-wide uppercase mb-4">
            Nossas Soluções
          </span>
          <h2 className="text-2xl md:text-4xl font-bold text-foreground-900 font-heading mb-4">
            Produtos REDENET
          </h2>
          <div className="w-16 h-1 bg-accent-500 mx-auto rounded-full mb-5" />
          <p className="text-foreground-600 text-base md:text-lg max-w-2xl mx-auto">
            Softwares completos para gestão educacional, reconhecimento facial, educação especial e avaliações de desempenho.
          </p>
        </div>

        <div className="max-w-5xl mx-auto space-y-6 md:space-y-8">
          {/* Featured IE Card */}
          {featuredProduct && (
            <div className="bg-background-50 border border-accent-400 rounded-xl p-6 md:p-10 relative ring-1 ring-accent-300">
              <span className="absolute -top-3 left-6 md:left-10 px-4 py-1.5 rounded-full bg-accent-500 text-background-50 text-xs font-bold shadow-sm">
                {featuredProduct.badge}
              </span>
              <div className="grid grid-cols-1 md:grid-cols-2 gap-6 md:gap-10 items-center">
                <div>
                  <div className="flex items-center gap-4 mb-5">
                    <img
                      src={featuredProduct.logo}
                      alt={featuredProduct.name}
                      className="h-20 w-20 object-contain rounded-lg"
                    />
                    <div>
                      <h3 className="text-2xl md:text-3xl font-bold text-foreground-900 font-heading">
                        {featuredProduct.name}
                      </h3>
                      <p className="text-sm text-accent-600 font-medium mt-0.5">
                        {featuredProduct.subtitle}
                      </p>
                    </div>
                  </div>
                  <p className="text-sm md:text-base text-foreground-600 leading-relaxed mb-5">
                    {featuredProduct.description}
                  </p>
                  <div className="inline-flex items-center gap-2 px-4 py-2 rounded-full bg-primary-50 border border-primary-200 text-primary-700 text-xs font-semibold">
                    <div className="w-4 h-4 flex items-center justify-center">
                      <i className="ri-arrow-up-line" />
                    </div>
                    Nova versão do iEscolar Online
                  </div>
                </div>
                <div>
                  <h4 className="text-sm font-semibold text-foreground-900 uppercase tracking-wide mb-4">
                    Principais Funcionalidades
                  </h4>
                  <ul className="grid grid-cols-1 sm:grid-cols-2 gap-3">
                    {featuredProduct.features.map((feature) => (
                      <li key={feature} className="flex items-start gap-3">
                        <div className="w-6 h-6 rounded-full bg-accent-50 border border-accent-200 flex items-center justify-center shrink-0 mt-0.5">
                          <i className="ri-check-line text-accent-600 text-xs" />
                        </div>
                        <span className="text-sm text-foreground-700">{feature}</span>
                      </li>
                    ))}
                  </ul>
                  <a
                    href={featuredProduct.website}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="inline-flex items-center gap-2 mt-6 px-6 py-2.5 rounded-full bg-primary-600 text-background-50 text-sm font-semibold hover:bg-primary-700 transition-colors"
                  >
                    Saiba mais
                    <div className="w-4 h-4 flex items-center justify-center">
                      <i className="ri-arrow-right-line" />
                    </div>
                  </a>
                </div>
              </div>
            </div>
          )}

          {/* Other Products Grid */}
          <div className="grid grid-cols-1 md:grid-cols-2 gap-6 md:gap-8">
            {otherProducts.map((product) => (
              <div
                key={product.id}
                className="group bg-background-50 border border-background-200 rounded-xl p-6 md:p-8 hover:border-primary-200 transition-all hover:shadow-sm relative"
              >
                {product.badge && (
                  <span className="absolute -top-3 right-6 px-3 py-1 rounded-full bg-secondary-500 text-background-50 text-xs font-bold shadow-sm">
                    {product.badge}
                  </span>
                )}
                <div className="flex items-start gap-5 mb-5">
                  {product.logo ? (
                    <img
                      src={product.logo}
                      alt={product.name}
                      className="h-14 w-14 object-contain rounded-lg shrink-0"
                    />
                  ) : (
                    <div className="w-14 h-14 rounded-lg bg-primary-50 flex items-center justify-center shrink-0">
                      <div className="w-7 h-7 flex items-center justify-center">
                        <i className={`ri-${product.id === "rface" ? "scan-line" : product.id === "iluminia" ? "lightbulb-line" : "bar-chart-2-line"} text-primary-600 text-xl`} />
                      </div>
                    </div>
                  )}
                  <div>
                    <h3 className="text-xl md:text-2xl font-bold text-foreground-900 font-heading">
                      {product.name}
                    </h3>
                    <p className="text-sm text-accent-600 font-medium mt-0.5">
                      {product.subtitle}
                    </p>
                  </div>
                </div>
                <p className="text-sm text-foreground-600 leading-relaxed mb-5">
                  {product.description}
                </p>
                <div className="flex flex-wrap gap-2 mb-6">
                  {product.features.slice(0, 3).map((feature) => (
                    <span
                      key={feature}
                      className="px-3 py-1 rounded-full bg-background-100 text-foreground-600 text-xs font-medium border border-background-200"
                    >
                      {feature}
                    </span>
                  ))}
                </div>
                <a
                  href={product.website}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="inline-flex items-center gap-1.5 text-sm font-semibold text-primary-600 hover:text-primary-700 transition-colors"
                >
                  Acessar site
                  <div className="w-4 h-4 flex items-center justify-center">
                    <i className="ri-arrow-right-line" />
                  </div>
                </a>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}